import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import IconEnum from "../../../../enums/icon.enum";
import SizeEnum from "../../../../enums/size.enum";
import PositionEnum from "../../../../enums/position.enum";
import PriorityEnum from "../../../../enums/priority.enum";
import PreloaderTypeEnum from "../../../../enums/preloader-type.enum";
import Preloader from "../../../preloader/preloader";
import Action from "../../../action/action";

import { IButton, ButtonTypeEnum } from "./button.props";

const Button = (props: IButton) => {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(props.enabled);
  const [loader, setLoader] = useState(false);
  let title = t("Continue");
  let priority = PriorityEnum.PRIMARY;
  let icon = IconEnum.ARROW_RIGHT;
  let textPosition = PositionEnum.LEFT;

  switch (props.type) {
    case ButtonTypeEnum.CHECK_ANSWER:
      title = t("Check Answer");
      priority = PriorityEnum.SUCCESS;
      icon = IconEnum.CHECK_SQUARE;
      textPosition = PositionEnum.RIGHT;
      break;
    case ButtonTypeEnum.SUBMIT:
      title = t("Submit");
      break;
    case ButtonTypeEnum.CONTINUE:
      title = t("Continue");
      break;
    case ButtonTypeEnum.TRY_AGAIN:
      title = t("Try Again");
      break;
  }

  if (props.hideLoader && loader) {
    setLoader(false);
  }
  const handleClick = () => {
    setEnabled(false);
    props.resetLoader ? props.resetLoader() : "";
    if (props.type !== ButtonTypeEnum.TRY_AGAIN) setLoader(true);

    if (props.callback && typeof props.callback === "function") {
      props.callback();
    }
  };

  useEffect(() => {
    setEnabled(props.enabled);
  }, [props, setEnabled]);

  return (
    <>
      {loader && (
        <Preloader type={PreloaderTypeEnum.THREE_DOTS} fill={PriorityEnum.PRIMARY} className="d-flex mx-auto" />
      )}
      {!loader && (
        <Action
          enabled={enabled}
          callback={handleClick}
          text={title}
          priority={priority}
          className={"ft-btns " + props.type !== ButtonTypeEnum.TRY_AGAIN ? "footer-action-btn" : ""}
          icon={
            props.type !== ButtonTypeEnum.SUBMIT
              ? {
                  icon: icon,
                  size: SizeEnum.LARGE,
                  title: title,
                  textPosition: textPosition
                }
              : undefined
          }
        />
      )}
    </>
  );
};

export default Button;
